import type { FeatureTheme } from '../lib/productBranding'
import { productThemes } from '../lib/productBranding'

type PageLoadingProps = {
  show: boolean
  theme?: FeatureTheme
}

export default function PageLoading({ show, theme = productThemes.practiceIntel }: PageLoadingProps) {
  if (!show) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/90" aria-hidden>
      <div className="flex flex-col items-center gap-4">
        <div
          className="w-12 h-12 rounded-full animate-spin"
          style={{
            borderWidth: 4,
            borderStyle: 'solid',
            borderColor: theme.spinnerBorder,
            borderTopColor: theme.spinnerTrack,
          }}
        />
        <span className="text-sm font-semibold text-gray-700">Loading...</span>
      </div>
    </div>
  )
}
